import ApplicationController from './application_controller'
import { get_csrf_token } from '../app/csrf_token.js'

export default class extends ApplicationController {

	static values = {
		'url':    String,
		'method': { type: String, default: 'POST' },
		'turboStream': Boolean,
		'data':   Object,
	}

	// Per Turbo request structure, the response needs to be a turbo-stream or
	// full page response with status code 303
	sendRequest(_event) {
		fetch(this.urlValue, {
			method: this.methodValue,
			headers: this.getHeaders(),
			body: JSON.stringify(this.dataValue)
		})
		.then(r => r.text())
		.then(html => Turbo.renderStreamMessage(html))
	}

	getHeaders() {
		const headers = {
			'X-CSRF-Token': get_csrf_token(),
			'Content-Type': 'application/json',
		}

		if (this.hasTurboFrameValue) {
			headers['turbo-frame'] = this.turboFrameValue
		}

		return headers
	}

}
